import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qkuw7mime: FaireProductEntity = {
  token: "p_4qkuw7mime",
  type: "product",
  name: "Large Gold Virgin Mary Necklace, Religious Jewelry",
  brandToken: "b_753b7wy8",
  brandName: "Laalee Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/6c5c28c3303759db194fcdf434e2f409c3fdb15b6ebeac3b0e1bab7fa032e3c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f340c85765227152d3732585322b2f4b99bff4d7b304ab00da022c588efc5471.jpeg",
    "https://cdn.faire.com/fastly/ac74aee57e29b72aa4187aae4e3bcc154d94b86cdb79d269a3a557411168f2e8.jpeg",
    "https://cdn.faire.com/fastly/1b8a43925a7d3ef5aa52e6b54df86168e2fad4f70f98cc8695d22fae07ef3330.jpeg",
    "https://cdn.faire.com/fastly/ccb787e260e11b820cb2087d0dfee16fd998aaccb46880130703a01496b4e5ef.jpeg",
    "https://cdn.faire.com/fastly/1c0c33477f03ea776ba05616b132ff5214bdb18456b42168f7ab577e9cfe251b.jpeg",
    "https://cdn.faire.com/fastly/c71a39dfa89fe76f9e369c1b68820c569ffab1dca52620345fe9c2a7470d9e85.jpeg",
  ],
  priceDollars: 18.01,
  description: '14x20mm pendant on a 14k gold filled chain. 18".',
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:55.794Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
